import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const clusterOverviewTabContent = EntityContentBlueprint.make({
  name: 'cluster-overview',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: { kind: 'cluster' },
    loader: () => import('./components').then(m => <m.ClusterOverviewTab />),
  },
});

const clusterResourcesOverviewTabContent = EntityContentBlueprint.make({
  name: 'cluster-resources-overview',
  params: {
    path: '/cluster-resources',
    title: 'Cluster Resources',
    group: 'resources',
    filter: { kind: 'cluster' },
    loader: () =>
      import('./components').then(m => <m.ClusterResourcesOverviewTab />),
  },
});

const clusterResourceOverviewTabContent = EntityContentBlueprint.make({
  name: 'cluster-resource-overview',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: { kind: 'ClusterResource' },
    loader: () =>
      import('./components').then(m => <m.ClusterResourceOverviewTab />),
  },
});

const projectClustersTabContent = EntityContentBlueprint.make({
  name: 'project-clusters',
  params: {
    path: '/clusters',
    title: 'Clusters',
    group: 'resources',
    filter: { kind: 'Domain' },
    loader: () => import('./components').then(m => <m.ProjectClustersTab />),
  },
});

const accountClustersTabContent = EntityContentBlueprint.make({
  name: 'account-clusters',
  params: {
    path: '/clusters',
    title: 'Clusters',
    group: 'resources',
    filter: { kind: 'Account' },
    loader: () => import('./components').then(m => <m.AccountClustersTab />),
  },
});

export default [
  clusterOverviewTabContent,
  clusterResourcesOverviewTabContent,
  clusterResourceOverviewTabContent,
  projectClustersTabContent,
  accountClustersTabContent,
];
